import { Fancybox } from '@fancyapps/ui';

export default function modalGallery() {
    const INIT_CLASS = 'js--fancybox-gallery';
    const galleryInitEls = document.querySelectorAll(`.${INIT_CLASS}`);

    galleryInitEls.forEach((initEl, idx) => {
        initEl.classList.add(`${INIT_CLASS}-${idx}`);

        Fancybox.bind(`.${INIT_CLASS}-${idx} [data-fancybox-gallery]`, {
            closeButton: 'outside',
            mainClass: 'modal-gallery',
            groupAll: true,
            template: {
                closeButton: `
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 22L22 2" stroke="white" stroke-width="2"></path>
                        <path d="M22 22L2 2" stroke="white" stroke-width="2"></path>
                    </svg>`
            },
            on: {
                '*': (fancybox, eventName) => {
                    if (fancybox === 'Carousel.change' || fancybox === 'done') {
                        setTimeout(() => {
                            const sliderContainer = document.querySelector('.fancybox__viewport');
                            const activeSlideId = sliderContainer.querySelector('.fancybox__slide.is-selected').getAttribute('data-index');
                            const pagination = sliderContainer.querySelector('.pagination-fraction');
                            const paginationFraction = `
                                 <span class="pagination-fraction"> ${+activeSlideId + 1}/${eventName.items.length} </span>`;
                            if (pagination) {
                                 pagination.remove();
                            }
                            sliderContainer.insertAdjacentHTML('beforeend', paginationFraction);
                        }, 300);
                    }

                    if (fancybox === 'closing') {
                        const sliderContainer = document.querySelector('.fancybox__viewport');
                        const pagination = sliderContainer.querySelector('.pagination-fraction');
                        if (pagination) {
                            pagination.remove();
                        }
                    }
                },
            },
            Carousel: {
                Navigation: {
                    prevTpl: `
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.0001 2L2.00012 12L12.0001 22" stroke="white" stroke-width="2"/>
                            <path d="M23 12L2 12" stroke="white" stroke-width="2"/>
                        </svg>`,
                    nextTpl: `
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.9999 2L21.9999 12L11.9999 22" stroke="white" stroke-width="2"/>
                            <path d="M1 12L22 12" stroke="white" stroke-width="2"/>
                        </svg>`,
                },
            },
            Toolbar: false,
            Thumbs: false,
        });
    });
}
